import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import type { UnitFormInterface } from '@zaoblako/shared/modules/catalog/dtos/unit/unit-form.dto';

import * as yup from 'yup';

/** Unit response body */
export interface UnitFindInterface extends UnitFormInterface {
  /** Unique identifier. Cannot be changed */
  id: number;
  /** Deletion mark */
  deleted: boolean;
  /** Identifier of this unit in Atrium CRM */
  atriumId?: number;
  /** Special code of this unit for Atrium CRM (using by some reports) */
  atriumCode?: string;
  /** Is unit exported to Atrium CRM */
  exportedToAtrium?: boolean;
  /** Is this unit using to distribute costs (`true` value must be a single for tenant) */
  distributeCosts?: boolean;
}

/** Unit response body DTO */
export const UnitFindDto = SerdeDtoClass.create<UnitFindInterface>(CatalogDtosKeysEnum.UNIT_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  deleted: {
    label: 'Помечен удаленным',
    serializer: yup.boolean(),
  },
  atriumId: {
    optional: true,
    label: 'Номер в "Атриум CRM"',
    serializer: yup.number(),
  },
  atriumCode: {
    label: 'Код для "Атриума"',
    optional: true,
    serializer: yup.string(),
  },
  exportedToAtrium: {
    optional: true,
    label: 'Синхронизирован с "Атриум CRM"',
    serializer: yup.boolean(),
  },
  distributeCosts: {
    optional: true,
    label: 'Распределить затраты',
    serializer: yup.boolean(),
  },
  color: {
    optional: true,
    label: 'Цвет',
    serializer: yup.string(),
  },
  short: {
    optional: true,
    label: 'Сокращенное название',
    serializer: yup.string(),
  },
});
